import { Tooltip } from '@mui/material';
import classNames from 'classnames';
import React, { forwardRef } from 'react';
import css from '../MediaCard.module.scss';

type StatusPillProps = {
  children: React.ReactNode;
  className?: string;
  tooltip?: string;
  mini?: boolean;
  status?: string;
};

const isProgressingStatus = (status?: string): boolean => {
  if (!status) return false;
  const progressingStatuses = ['uploading', 'queued', 'processing'];
  return progressingStatuses.includes(status);
};

export const StatusPill = forwardRef<HTMLDivElement, StatusPillProps>(
  ({ children, className, tooltip, mini = false, status }, ref) => {
    const progressing = isProgressingStatus(status);
    const content = (
      <div
        ref={ref}
        className={classNames(
          mini ? css.miniCenterPill : css.centerPill,
          progressing && (mini ? css.miniCenterPillProgressing : css.centerPillProgressing),
          className,
        )}
      >
        <div className={classNames(mini ? css.miniCenterPillContents : css.centerPillContents)}>
          {children}
        </div>
      </div>
    );

    return tooltip ? (
      <Tooltip title={tooltip} placement="top">
        {content}
      </Tooltip>
    ) : (
      content
    );
  },
);

StatusPill.displayName = 'StatusPill';
